<template>
  <div>
       <vue-headful
            title="Account - Girish Jewellers"
            description="Girish Jewellers is the jewellery shop having varity of golden and silver ornament designs of products like bangles, bracelets, golden sets,pandent set, rings, wedding bands in rajkot gujarat india."
            keywords= "golden ornaments, silver ornaments, bangles, bracelets, golden sets,pandent set, rings, wedding bands, online order,best, purity, jewellery shop, in rajkot gujarat india"
            abstract = "Golden and silver ornaments online orering and selling shop"
            author = "Girish Jewellers"
            copyright = "Girish Jewellers"
            robots = "INDEX,FOLLOW"
        />    
    <LeftPanel msg="Welcome to Your Vue.js App"/>
    <div>
      <div class="page-box">
        <div class="page-box-content">
          <div id="header-area">          
          <TopHeader msg="Welcome to Your Vue.js App"/>
          <Header msg="Welcome to Your Vue.js App"/>
          </div>
            <section id="main">
                <div class="container"> 
                    <article class="content">

                      <div class="row bottom-padding">
                    <div class="span12 title-box" style="margin-bottom:20px;">
                      <h1 class="title">Welcome {{Session.first_name}} {{Session.last_name}}! </h1>
                    </div>
                    </div>
                    <div class="row services">
                    
                    <div class="span3 text-small features-block">
                      <router-link class="header-box" to="/order-history">
                      <div class="icon-box">
                        <i class="fa fa-th-list"></i>
                      </div>
                      <h6>Order History</h6>
                      </router-link>
                      <div>Review your online orders you have made using this account.</div>
                    </div><!-- .features-block -->

                    <div class="span3 text-small features-block">
                      <router-link class="header-box" to="/update-profile">
                      <div class="icon-box">
                        <i class="fa fa-edit"></i>
                      </div>
                      <h6>Update Profile</h6>
                      </router-link>
                      <div>Manage your contact information, billing address and delivery address.</div>
                    </div><!-- .features-block -->

                          <div class="span3 text-small features-block">
                      <router-link class="header-box" to="/change-password">
                      <div class="icon-box">
                        <i class="fa fa-lock"></i>
                      </div>
                      <h6>Change Password</h6>
                      </router-link>
                      <div>For security reasons we recommend you to change your password regularly.</div>
                    </div><!-- .features-block -->


                    <div class="span3 text-small features-block">
                      <a class="header-box" href="javascript:void(0);" v-on:click="Logout">
                      <div class="icon-box">
                        <i class="fa fa-sign-out"></i>
                      </div>
                      <h6>Logout</h6>
                      </a>
                      <div>For security reasons we recommend you to logout of your account when you're finished working with it.</div>
                    </div><!-- .features-block -->
                </div>
        
  
                   </article>
                </div>
            </section>         
        <Footer msg="Welcome to Your Vue.js App" v-if="isMobile()"/>
        
        </div><!-- .page-box-content -->
        </div><!-- .page-box -->
     </div>
      <FooterWeb msg="Welcome to Your Vue.js App" v-if="!isMobile()"/>
    </div>
</template>

<script>
// @ is an alias to /src
import $ from 'jquery'
import LeftPanel from '@/components/LeftPanel.vue'
import TopHeader from '@/components/TopHeader.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import FooterWeb from '@/components/FooterWeb.vue'
import Common from '@/common.js'
import {mapGetters, mapActions} from "vuex";
import vueHeadful from 'vue-headful';


export default {
  name: 'Account',
  components: {
    vueHeadful,
    LeftPanel,
    TopHeader,
    Header,
    Footer,
    FooterWeb
    },created(){
        this.getSession;
    },
    computed:mapGetters(["Session"]),
    watch:{
        Session(newValue) {
          if(!newValue.is_login)
            {
              this.$router.push('/login')
            }
          }
    },
    mounted:function(){
      this.loadOnMount();
    },
    data:function(){
        return {results: {} };
    },
    methods:{
      ...mapActions(["getSession","logoutSession"]),
      isMobile:function(){
   return Common.isMobile();
},Logout:function()
  {
          this.logoutSession();
          this.$router.push("/login");
  },

loadOnMount: function() {
      
      Common.stopAjaxLoader();
      $.get('js/main.js', function(data) {
        eval(data);
   //process text file line by line
   //$('#div').html(data.replace('n',''));
        });
    }

  }
    
}
</script>